<template>
  <div v-if="visible" class="native-prompt" role="alert">
    <div class="native-prompt__content">
      <img
        class="native-prompt__icon"
        :src="faviconUrl"
        alt="Logo"
        width="48"
        height="48"
      />
      <div class="native-prompt__text">
        <div class="native-prompt__title">
          <span>{{ siteName }}</span> souhaite vous envoyer des notifications
        </div>
        <div class="native-prompt__sub">
          Recevez des alertes et des messages même lorsque vous n'utilisez pas le site.
        </div>
      </div>
      <div class="native-prompt__actions">
        <button class="native-prompt__btn native-prompt__btn--later" @click="dismiss">
          Plus tard
        </button>
        <button class="native-prompt__btn native-prompt__btn--allow" @click="allow">
          Autoriser
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NativeNotificationPrompt',
  props: {
    activationFn: {
      type: Function,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.value,
      siteName: process.env.VUE_APP_APP_NAME || 'PettyCash',
      faviconUrl: '/favicon.ico',
    };
  },
  watch: {
    value(val) {
      this.visible = val;
    },
  },
  methods: {
    async allow() {
      this.visible = false;
      this.$emit('input', false);
      try {
        await this.activationFn();
      } catch (e) {
        console.warn('Échec de l’activation:', e);
      }
    },
    dismiss() {
      this.visible = false;
      this.$emit('input', false);
      localStorage.setItem('notif_ignored', String(Date.now() + 3 * 24 * 3600 * 1000));
    },
  },
};
</script>

<style scoped>
.native-prompt {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99999;
  width: min(560px, 94%);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  padding: 20px 24px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  animation: slideDown 0.4s ease;
}
.native-prompt__content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.native-prompt__icon {
  flex-shrink: 0;
  border-radius: 8px;
  width: 48px;
  height: 48px;
  background: #f0f0f0;
  padding: 4px;
}
.native-prompt__text {
  flex: 1;
  min-width: 150px;
}
.native-prompt__title {
  font-size: 15px;
  font-weight: 500;
  color: #1a1a1a;
  line-height: 1.3;
  margin-bottom: 2px;
}
.native-prompt__title span {
  font-weight: 600;
}
.native-prompt__sub {
  font-size: 13px;
  color: #5f5f5f;
  line-height: 1.4;
}
.native-prompt__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}
.native-prompt__btn {
  padding: 6px 18px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  white-space: nowrap;
}
.native-prompt__btn--later {
  background: transparent;
  color: #5f5f5f;
}
.native-prompt__btn--later:hover {
  background: #f0f0f0;
}
.native-prompt__btn--allow {
  background: #1a73e8;
  color: #fff;
}
.native-prompt__btn--allow:hover {
  background: #1557b0;
}
.native-prompt__btn--allow:active {
  transform: scale(0.96);
}
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}
@media (max-width: 500px) {
  .native-prompt {
    padding: 16px;
  }
  .native-prompt__content {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
  }
  .native-prompt__icon {
    align-self: center;
  }
  .native-prompt__actions {
    justify-content: center;
    margin-left: 0;
  }
}
</style>
